"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitHappyJoe = void 0;
require('select2');
function InitHappyJoe() {
    var isBlackNav = false;
    window.addFullWidth = () => {
        if (!$(".content-wrapper").hasClass("has-bg-image")) {
            $(".o-navigation-wrapper").addClass("u-z-999 u-absolute u-full-width");
            $(".content-wrapper").addClass("has-bg-image");
            $(".o-navigation").removeClass("black-links");
            $(".o-mobile-menu").removeClass("black-links");
            $(".blue-company-logo").hide();
            $(".white-company-logo").show();
            $(".o-mobile-logo.blue").hide();
            $(".o-mobile-logo.white").show();
        }
        isBlackNav = false;
    };
    window.removeFullWidth = (blackNav) => {
        isBlackNav = blackNav;
        if ($(".content-wrapper").hasClass("has-bg-image")) {
            $(".o-navigation-wrapper").removeClass("u-z-999 u-absolute u-full-width");
            $(".content-wrapper").removeClass("has-bg-image");
        }
        $(".o-navigation").addClass("black-links");
        $(".o-mobile-menu").addClass("black-links");
        $(".blue-company-logo").show();
        $(".white-company-logo").hide();
        $(".o-mobile-logo.blue").show();
        $(".o-mobile-logo.white").hide();
    };
    window.closeLanguage = () => {
        $("#page-wide-language-wrapper").removeClass("display-language-field");
        $("body").removeClass("u-ofh");
        $(".main-language-button i").html("language");
        $(".o-mobile-menu").removeClass("u-fixed");
        if (isBlackNav) {
            $(".blue-company-logo").show();
            $(".white-company-logo").hide();
            $(".o-mobile-logo.blue").show();
            $(".o-mobile-logo.white").hide();
            $(".o-navigation, .o-mobile-menu").addClass("black-links");
            $(".o-navigation, .o-mobile-menu").addClass("s-000");
            $(".o-navigation, .o-mobile-menu").removeClass("FFF");
        }
    };
    window.openLanguage = () => {
        $("#page-wide-language-wrapper").addClass("display-language-field");
        $("body").addClass("u-ofh");
        $(".main-language-button i").html("close");
        $(".o-mobile-menu").addClass("u-fixed");
        if (isBlackNav) {
            $(".blue-company-logo").hide();
            $(".white-company-logo").show();
            $(".o-mobile-logo.blue").hide();
            $(".o-mobile-logo.white").show();
            $(".o-navigation, .o-mobile-menu").addClass("FFF");
            $(".o-navigation, .o-mobile-menu").removeClass("black-links");
            $(".o-navigation, .o-mobile-menu").removeClass("s-000");
        }
    };
    window.openMobileNav = () => {
        if (isBlackNav) {
            $(".blue-company-logo").hide();
            $(".white-company-logo").show();
            $(".o-mobile-logo.blue").hide();
            $(".o-mobile-logo.white").show();
            $(".o-navigation, .o-mobile-menu").addClass("FFF");
            $(".o-navigation, .o-mobile-menu").removeClass("black-links");
        }
    };
    $(document).ready(function () {
        isBlackNav = $('.o-navigation').hasClass('s-000');
        if (isBlackNav) {
            $('.o-mobile-menu').addClass('black-links');
        }
        //Arrow glyphs are hard-coded to HTML source, so clear html arrows away and introduce Material Icon arrows via CSS
        setTimeout(function () {
            $('.slick-dots.slick-arrow .s-circle.arrow-circle, .o-back-to-top .s-circle.arrow-circle').empty();
            $('.slick-dots.slick-arrow .s-circle.arrow-circle').html('<i class="material-icons">arrow_downward</i>');
            $('.o-back-to-top .s-circle.arrow-circle').html('<i class="material-icons">arrow_upward</i>');
        }, 50);
        //Initialize select2 for Happyjoe Contact form
        $('.Form__Element.FormSelection select').hide();
        $('.Form__Element.FormSelection select').select2({
            minimumResultsForSearch: Infinity,
            width: 'resolve',
            dropdownParent: $('.Form__MainBody')
        });
        // Add space before Image content block if it's the first element of the content area
        $('[data-block-type]').each((i, block) => {
            if (i === 0 && $(block).data('block-type') === 'imagecontentblock') {
                $(block).addClass("_md-u-mt-6");
            }
        });
        // Attempt to fix quote positioning for Safari based browsers by detecting Apple platforms and appending quote position altering CSS classes to elements
        var isSafari = (navigator.platform && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform));
        if (isSafari) {
            $(".content-wrapper, .o-age-validation__container").addClass('safari-quote-positioning');
            $(".o-brand-footer-customization").addClass("safari-quote-positioning-footer");
        }
    });
}
exports.InitHappyJoe = InitHappyJoe;
